export const COMISSAO = 'Comissão';
export const TIPO_USUARIO = 'Tipo Usuário';
export const TIPO_USUARIO_TITULO = 'Tipo de Usuário';
export const SUSPENDER_USUARIO = 'Suspender Usuário na Distribuição de Processos';
export const COMISSAO_ADV_EXTERNO = 'Comissão com Adv. Externo';
export const COMPARTILHAR_COMISSAO = 'Compartilhar Comissão';
